import { twMerge } from 'tailwind-merge';

export const AdultRoundIcon = ({
  className,
  fillOpacity = 0.6,
  color = 'white',
}: {
  fillOpacity?: number;
  color?: string;
  className?: string;
}) => (
  <svg
    className={twMerge('size-[16px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.9">
      <rect width="16" height="16" rx="8" fill="black" fillOpacity={fillOpacity} />
      <path
        d="M6.29457 4.69209H5.14549L3.5 5.75844V6.85237L5.05356 5.85956H5.09033V11.3476H6.29457V4.69209Z"
        fill={color}
      />
      <path
        d="M9.89847 4.60016C8.42305 4.59097 7.44403 5.57918 7.44403 6.87995C7.44862 8.13934 8.36789 9.04482 9.55834 9.04022C10.2892 9.04482 10.9326 8.7001 11.2682 8.12096H11.3417C11.3325 9.55042 10.7902 10.4007 9.82493 10.4007C9.22281 10.4007 8.81374 10.0652 8.69423 9.53663H7.50838C7.65546 10.6398 8.54255 11.4395 9.82493 11.4395C11.4612 11.4395 12.5 10.1112 12.5 7.8176C12.4954 5.38614 11.1992 4.60935 9.89847 4.60016ZM8.6115 6.85237C8.6023 6.13993 9.15846 5.56999 9.90766 5.56539C10.6523 5.56999 11.1946 6.16751 11.1946 6.84317C11.1992 7.53263 10.6293 8.13015 9.88928 8.13015C9.14467 8.13015 8.6115 7.5694 8.6115 6.85237Z"
        fill={color}
      />
      <rect
        x="0.25"
        y="0.25"
        width="15.5"
        height="15.5"
        rx="7.75"
        stroke={color}
        strokeOpacity="0.3"
        strokeWidth="0.5"
      />
    </g>
  </svg>
);
